/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - CSS
 */
import './styles/Dropdown.css'

/**
 *     Import
 *     - Icons
 */
import { DropdownArrowIcon } from '../../../images/icons/DropdownArrow/DropdownArrow'

/**
 * Dropdown component
 * @param  {array}     itemList    [array of objects with value and text for each option {'value', 'text'}]
 * @param  {string}    label       [Item label]
 */
export class Dropdown extends React.Component<any, any> {

    constructor(props: any) {
        super(props)

        this.state = {
            open: false,
            active: false,
            selected: ['', ''],
        }
    }
    componentWillMount() {
        if (this.props.selected !== undefined) {
            this.setState({ selected: this.props.selected })
            this.props.setFieldValue(this.props.name, this.props.selected[0])
        }
    }

    toggleList = () => {
        if (!this.props.disableDropdown) {
            this.setState({ open: !this.state.open })
        }
    }

    selectItem = (item: any) => {
        this.setState({ selected: item })
        this.props.setFieldValue(this.props.name, item[0])
        this.toggleList()
        this.setState({ active: true })
    }

    handleClickOutside = (evt) => {
        if (this.state.open) {
            this.toggleList()
        }
    }

    render() {

        const { itemList, label, labelShow = true } = this.props

        let listStyles = {
            height: (this.state.open) ? `${itemList.length * 35}px` : '0px',
        }

        return (
            <div className={`dropdown${(this.state.open) ? ' open' : ''}`}>
                {labelShow && <div className={`dropdown__label${(this.state.active) ? ' active' : ''}`}>{label}</div>}
                <div
                    className={`dropdown__selected ${(itemList.length <= 1) ? 'disabled' : ''}`}
                    onClick={this.toggleList}
                >
                    <span>{(this.state.selected[1] !== '') ? this.state.selected[1] : label}</span>
                    {!this.props.disableDropdown ? <DropdownArrowIcon color={'#F07662'} /> : null}
                </div>
                <div
                    className="dropdown__list"
                    style={listStyles}
                >
                    {itemList.map((item, i) => (
                        <div
                            key={i}
                            className="dropdown__item"
                            data-value={item.value}
                            onClick={(e) => this.selectItem([item.value, item.text])}
                        >
                            {item.text}
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Dropdown/Dropdown.tsx